import { lazyRouteComponent } from "@tanstack/react-router";
import type { At } from "../../router";

export const SalesRoutes = (at: At) => [
  at("/sales", lazyRouteComponent(() => import("./Finance"), "SalesOverview")),
  at("/sales/quotes", lazyRouteComponent(() => import("./Documents"), "QuotesPage")),
  at("/sales/quotes/new", lazyRouteComponent(() => import("./Documents"), "QuoteEditor")),
  at("/sales/quotes/$id", lazyRouteComponent(() => import("./Documents"), "QuoteEditor")),
  at("/sales/invoices", lazyRouteComponent(() => import("./Documents"), "InvoicesPage")),
  at("/sales/invoices/$id", lazyRouteComponent(() => import("./Documents"), "InvoiceEditor")),
  at("/sales/payables", lazyRouteComponent(() => import("./Finance"), "PayablesPage")),
  at("/sales/schedule", lazyRouteComponent(() => import("./Finance"), "SchedulePage")),
  at("/sales/bank", lazyRouteComponent(() => import("./Bank"), "BankPage")),
  at("/sales/ledger", lazyRouteComponent(() => import("./Finance"), "LedgerPage")),
  at("/sales/products", lazyRouteComponent(() => import("./Finance"), "ProductsPage")),
  at("/sales/reports", lazyRouteComponent(() => import("./Reports"), "SalesReports")),
];
